import { ReactNode } from "react"

export const serviceIcons: Record<string, ReactNode> = {
  "GPS Tracking": (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.5 13C25.5 15.75 24.743 17.487 23.245 19.435C22.483 20.425 21.535 21.462 20.385 22.717C19.241 23.968 17.909 25.422 16.401 27.227L17.169 27.867C18.66 26.083 19.979 24.643 21.123 23.393C22.264 22.146 23.245 21.075 24.038 20.044C25.648 17.951 26.5 16.004 26.5 13H25.5ZM15.598 27.226C14.091 25.422 12.759 23.968 11.614 22.717C10.465 21.462 9.516 20.424 8.755 19.435C7.257 17.487 6.5 15.749 6.5 13H5.5C5.5 16.004 6.352 17.951 7.963 20.044C8.755 21.074 9.736 22.146 10.876 23.393C12.022 24.643 13.34 26.083 14.831 27.867L15.599 27.227L15.598 27.226ZM6.5 13C6.5 10.4804 7.50089 8.06408 9.28249 6.28249C11.0641 4.50089 13.4804 3.5 16 3.5V2.5C10.201 2.5 5.5 7.201 5.5 13H6.5ZM16 3.5C18.5196 3.5 20.9359 4.50089 22.7175 6.28249C24.4991 8.06408 25.5 10.4804 25.5 13H26.5C26.5 7.201 21.799 2.5 16 2.5V3.5ZM16.401 27.227C16.3515 27.2852 16.29 27.3309 16.2207 27.363C16.1513 27.395 16.0759 27.4116 15.9995 27.4116C15.9231 27.4116 15.8477 27.395 15.7783 27.363C15.709 27.3309 15.6475 27.2842 15.598 27.226L14.831 27.867C14.9743 28.0376 15.1532 28.1757 15.3552 28.2697C15.5571 28.3638 15.7772 28.4126 16 28.4126C16.2228 28.4126 16.4429 28.3638 16.6448 28.2697C16.8468 28.1757 17.0257 28.0376 17.169 27.867L16.401 27.227Z"
        fill="#1A1A1A"
      />
      <path
        d="M16 17C18.2091 17 20 15.2091 20 13C20 10.7909 18.2091 9 16 9C13.7909 9 12 10.7909 12 13C12 15.2091 13.7909 17 16 17Z"
        stroke="#1A1A1A"
      />
    </svg>
  ),
  "Door to door delivery": (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 8C8.88071 8 10 6.88071 10 5.5C10 4.11929 8.88071 3 7.5 3C6.11929 3 5 4.11929 5 5.5C5 6.88071 6.11929 8 7.5 8Z"
        stroke="#1A1A1A"
      />
      <path
        d="M25.5 10C26.8807 10 28 8.88071 28 7.5C28 6.11929 26.8807 5 25.5 5C24.1193 5 23 6.11929 23 7.5C23 8.88071 24.1193 10 25.5 10Z"
        stroke="#1A1A1A"
      />
      <path
        d="M11 13H10.5C10.5 13.1326 10.5527 13.2598 10.6464 13.3536C10.7402 13.4473 10.8674 13.5 11 13.5V13ZM16.5 13H17C17 12.8674 16.9473 12.7402 16.8536 12.6464C16.7598 12.5527 16.6326 12.5 16.5 12.5V13ZM16.5 16V16.5C16.6326 16.5 16.7598 16.4473 16.8536 16.3536C16.9473 16.2598 17 16.1326 17 16H16.5ZM8.5 11.5C8.5 11.3674 8.44732 11.2402 8.35355 11.1464C8.25979 11.0527 8.13261 11 8 11C7.86739 11 7.74021 11.0527 7.64645 11.1464C7.55268 11.2402 7.5 11.3674 7.5 11.5H8.5ZM11 23H11.5C11.4999 22.9163 11.4787 22.8341 11.4385 22.7607C11.3984 22.6873 11.3404 22.6252 11.27 22.58L11 23ZM11 29H10.5C10.5 29.1326 10.5527 29.2598 10.6464 29.3536C10.7402 29.4473 10.8674 29.5 11 29.5V29ZM14 29V29.5C14.1326 29.5 14.2598 29.4473 14.3536 29.3536C14.4473 29.2598 14.5 29.1326 14.5 29H14ZM14 21.5H14.5C14.5001 21.4343 14.4873 21.3692 14.4622 21.3085C14.4372 21.2477 14.4004 21.1925 14.354 21.146L14 21.5ZM10 17.5H9.5C9.49988 17.5657 9.51272 17.6308 9.53777 17.6915C9.56282 17.7523 9.5996 17.8075 9.646 17.854L10 17.5ZM10.5 16C10.5 15.8674 10.4473 15.7402 10.3536 15.6464C10.2598 15.5527 10.1326 15.5 10 15.5C9.86739 15.5 9.74021 15.5527 9.64645 15.6464C9.55268 15.7402 9.5 15.8674 9.5 16H10.5ZM6 8.5H9V7.5H6V8.5ZM10.5 10V13H11.5V10H10.5ZM11 13.5H16.5V12.5H11V13.5ZM16 13V16H17V13H16ZM16.5 15.5H9V16.5H16.5V15.5ZM8.5 15V11.5H7.5V15H8.5ZM9 15.5C8.86739 15.5 8.74021 15.4473 8.64645 15.3536C8.55268 15.2598 8.5 15.1326 8.5 15H7.5C7.5 15.3978 7.65804 15.7794 7.93934 16.0607C8.22064 16.342 8.60218 16.5 9 16.5V15.5ZM3.5 10V14.678H4.5V10H3.5ZM6.944 20.987L10.73 23.421L11.27 22.58L7.485 20.146L6.945 20.987H6.944ZM10.5 23V29H11.5V23H10.5ZM11 29.5H14V28.5H11V29.5ZM14.5 29V21.5H13.5V29H14.5ZM14.354 21.146L10.354 17.146L9.646 17.854L13.646 21.854L14.354 21.146ZM10.5 17.5V16H9.5V17.5H10.5ZM3.5 14.678C3.49977 15.934 3.81499 17.17 4.41674 18.2725C5.01849 19.375 5.88749 20.3087 6.944 20.988L7.485 20.146C6.56941 19.5574 5.8163 18.7483 5.29476 17.7929C4.77321 16.8375 4.49994 15.7665 4.5 14.678H3.5ZM9 8.5C9.39782 8.5 9.77936 8.65804 10.0607 8.93934C10.342 9.22064 10.5 9.60218 10.5 10H11.5C11.5 9.6717 11.4353 9.34661 11.3097 9.04329C11.1841 8.73998 10.9999 8.46438 10.7678 8.23223C10.5356 8.00009 10.26 7.81594 9.95671 7.6903C9.65339 7.56466 9.3283 7.5 9 7.5V8.5ZM6 7.5C5.33696 7.5 4.70107 7.76339 4.23223 8.23223C3.76339 8.70107 3.5 9.33696 3.5 10H4.5C4.5 9.60218 4.65804 9.22064 4.93934 8.93934C5.22064 8.65804 5.60218 8.5 6 8.5V7.5Z"
        fill="#1A1A1A"
      />
      <path
        d="M5 18.5V23L2 28L4 29L8 24L8.5 21.5"
        stroke="#1A1A1A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11 7H18V13H11V7Z" stroke="#1A1A1A" strokeLinejoin="round" />
      <path d="M20 2H30V29H20V2Z" stroke="#1A1A1A" />
      <path
        d="M29 10.5C29.1326 10.5 29.2598 10.4473 29.3536 10.3536C29.4473 10.2598 29.5 10.1326 29.5 10C29.5 9.86739 29.4473 9.74021 29.3536 9.64645C29.2598 9.55268 29.1326 9.5 29 9.5V10.5ZM24.5 14V14.5C24.6326 14.5 24.7598 14.4473 24.8536 14.3536C24.9473 14.2598 25 14.1326 25 14H24.5ZM20 13.5C19.8674 13.5 19.7402 13.5527 19.6464 13.6464C19.5527 13.7402 19.5 13.8674 19.5 14C19.5 14.1326 19.5527 14.2598 19.6464 14.3536C19.7402 14.4473 19.8674 14.5 20 14.5V13.5ZM29 9.5H26.5V10.5H29V9.5ZM24 12V14H25V12H24ZM24.5 13.5H20V14.5H24.5V13.5ZM26.5 9.5C25.837 9.5 25.2011 9.76339 24.7322 10.2322C24.2634 10.7011 24 11.337 24 12H25C25 11.6022 25.158 11.2206 25.4393 10.9393C25.7206 10.658 26.1022 10.5 26.5 10.5V9.5ZM27.5 14C27.5 13.8674 27.4473 13.7402 27.3536 13.6464C27.2598 13.5527 27.1326 13.5 27 13.5C26.8674 13.5 26.7402 13.5527 26.6464 13.6464C26.5527 13.7402 26.5 13.8674 26.5 14H27.5ZM20 16.5C19.8674 16.5 19.7402 16.5527 19.6464 16.6464C19.5527 16.7402 19.5 16.8674 19.5 17C19.5 17.1326 19.5527 17.2598 19.6464 17.3536C19.7402 17.4473 19.8674 17.5 20 17.5V16.5ZM26.5 14V15H27.5V14H26.5ZM25 16.5H20V17.5H25V16.5ZM26.5 15C26.5 15.3978 26.342 15.7794 26.0607 16.0607C25.7794 16.342 25.3978 16.5 25 16.5V17.5C25.663 17.5 26.2989 17.2366 26.7678 16.7678C27.2366 16.2989 27.5 15.663 27.5 15H26.5Z"
        fill="#1A1A1A"
      />
      <path
        d="M26.5 17L30 20.5"
        stroke="#1A1A1A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "Solo Rides (VIP)": (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 6H4C2.89543 6 2 6.89543 2 8V24C2 25.1046 2.89543 26 4 26H28C29.1046 26 30 25.1046 30 24V8C30 6.89543 29.1046 6 28 6Z"
        stroke="#1A1A1A"
      />
      <path d="M2 10.5H30" stroke="#1A1A1A" />
      <path
        d="M7 15L10 22L13 15M16 15V22"
        stroke="#1A1A1A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 22C19.5 22.1326 19.5527 22.2598 19.6464 22.3536C19.7402 22.4473 19.8674 22.5 20 22.5C20.1326 22.5 20.2598 22.4473 20.3536 22.3536C20.4473 22.2598 20.5 22.1326 20.5 22H19.5ZM20 15V14.5C19.8674 14.5 19.7402 14.5527 19.6464 14.6465C19.5527 14.7402 19.5 14.8674 19.5 15H20ZM20 15.5C20.517 15.5 21.169 15.506 21.69 15.714C21.938 15.814 22.133 15.951 22.266 16.137C22.398 16.319 22.5 16.587 22.5 17H23.5C23.5 16.413 23.352 15.931 23.077 15.551C22.8185 15.204 22.4659 14.9385 22.061 14.786C21.331 14.494 20.483 14.5 20 14.5V15.5ZM20.5 22V19H19.5V22H20.5ZM20.5 19V15H19.5V19H20.5ZM22.5 17C22.5 17.413 22.398 17.681 22.267 17.863C22.1191 18.0567 21.9184 18.2036 21.689 18.286C21.169 18.494 20.517 18.5 20 18.5V19.5C20.483 19.5 21.331 19.506 22.06 19.214C22.4653 19.0617 22.8183 18.7962 23.077 18.449C23.352 18.069 23.5 17.587 23.5 17H22.5ZM25 21.5C24.8674 21.5 24.7402 21.5527 24.6464 21.6465C24.5527 21.7402 24.5 21.8674 24.5 22C24.5 22.1326 24.5527 22.2598 24.6464 22.3536C24.7402 22.4473 24.8674 22.5 25 22.5V21.5ZM27 22.5C27.1326 22.5 27.2598 22.4473 27.3536 22.3536C27.4473 22.2598 27.5 22.1326 27.5 22C27.5 21.8674 27.4473 21.7402 27.3536 21.6465C27.2598 21.5527 27.1326 21.5 27 21.5V22.5ZM25 22.5H27V21.5H25V22.5Z"
        fill="#1A1A1A"
      />
    </svg>
  ),
  "Pet Transport": (
    <svg
      width="24"
      height="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
        fill="currentColor"
      />
      <path
        d="M15.88 8.29L10 14.17l-1.88-1.88a.996.996 0 1 0-1.41 1.41l2.59 2.59c.39.39 1.02.39 1.41 0L17.3 9.7a.996.996 0 0 0 0-1.41c-.39-.39-1.03-.39-1.42 0z"
        fill="currentColor"
      />
    </svg>
  ),
  "Vehicle Transport": (
    <svg
      width="24"
      height="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path
        d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 7h10.29l1.08 3.11H5.77L6.85 7zM19 17H5v-5h14v5z"
        fill="currentColor"
      />
      <circle cx={7.5} cy={14.5} r={1.5} fill="currentColor" />
      <circle cx={16.5} cy={14.5} r={1.5} fill="currentColor" />
    </svg>
  ),
  "Pet Transport Expert": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="paint0_linear_expert"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#FFD700" />
          <stop offset="100%" stopColor="#FFA500" />
        </linearGradient>
      </defs>
      <circle cx="12" cy="12" r="10" fill="url(#paint0_linear_expert)" />
      <path
        d="M16 8.8L11.5 13.3l-1.5-1.5a.996.996 0 1 0-1.41 1.41l2.17 2.17c.39.39 1.02.39 1.41 0L16.7 10.2a.996.996 0 0 0 0-1.41c-.39-.38-1.03-.38-1.42 0z"
        fill="#FFFFFF"
      />
    </svg>
  ),
}
